<template>
  <section class="password-requirements">
    <p>{{ $t('validations.password.title') }}</p>
    <ul>
      <li>
        <svg-icon icon="check" :style="{ filter: hasMinCharacter ? 'none' : 'grayscale(1)' }" />
        <p>{{ $t('validations.password.minCharacters') }}</p>
      </li>
      <li>
        <svg-icon icon="check" :style="{ filter: hasUppercase ? 'none' : 'grayscale(1)' }" />
        <p>{{ $t('validations.password.hasUppercase') }}</p>
      </li>
      <li>
        <svg-icon icon="check" :style="{ filter: hasNumber ? 'none' : 'grayscale(1)' }" />
        <p>{{ $t('validations.password.hasNumber') }}</p>
      </li>
      <li>
        <svg-icon icon="check" :style="{ filter: hasLowercase ? 'none' : 'grayscale(1)' }" />
        <p>{{ $t('validations.password.hasLowercase') }}</p>
      </li>
      <li>
        <svg-icon icon="check" :style="{ filter: hasSymbol ? 'none' : 'grayscale(1)' }" />
        <p>{{ $t('validations.password.hasSymbol') }}</p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'PasswordRequirements',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasMinCharacter() {
      return this.modelValue.length >= 6;
    },
    hasNumber() {
      return /\d/.test(this.modelValue);
    },
    hasSymbol() {
      return /[!@#$%^&*(),.?":{}|<>]/.test(this.modelValue);
    },
    hasLowercase() {
      return /[a-z]/.test(this.modelValue);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.modelValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.password-requirements {
  background-color: #efefef;
  padding: 20px;
  border-radius: 12px;

  & > p {
    font-size: 14px;
    font-weight: bold;
    font-family: Montserrat;
  }

  & > ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    column-gap: 4px;

    li {
      display: flex;
      gap: 2px;

      p {
        margin: 0;
      }
    }
  }
}
</style>
